import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientCandidateList } from '../types';

const useNexhealthPatientCandidates = (
    agentId: string,
    customerId: string,
    enabled = false,
) => useHttpQuery<NexhealthPatientCandidateList>({
    pathname: `/organizations/${agentId}/apps/nexhealth/customers/${customerId}/patient-candidates?limit=10`,
    server: ACTIONS_BASE_URL,
    key: ['nexhealth', 'patient-candidates', agentId, customerId],
    queryOptions: {
        enabled: Boolean(agentId && customerId) && enabled,
        retry: false,
    },
});

export default useNexhealthPatientCandidates;
